import { OrbitControls } from "@react-three/drei";
import { Canvas, useFrame, useThree } from "@react-three/fiber";
import { useEffect, useMemo, useRef, useState } from "react";
import { Color, Vector4 } from "three";
import "./scene.css";
import { DoubleSide } from "three";
import vertexShader from "./shaders/vertex.js";
import fragmentShader from "./shaders/fragment.js";
import colors from "nice-color-palettes";

let ind = Math.floor(Math.random() * colors.length)
ind = 96;
console.log(ind)

let pallete = colors[ind];
export let pallete2 = colors[ind];
pallete = pallete.map((color) => new Color(color))



const LavaLamp = () => {
  const { camera } = useThree();
  // This reference will give us direct access to the mesh
  const time = useRef(0);
  const mesh = useRef();
     // Use the useControls hook to create a rotation slider

  // Use the useState hook to store the rotation values
  const [rotationValues, setRotationValues] = useState({ x: -1, y: 1, z: 2.2 });


  const uniforms = useMemo(
    () => ({
          time: { value: 0 },
          uColor: { value: pallete },
          resolution: { value: new Vector4() },
    }),
    []
  );


  useEffect(() => {
    window.getCameraPosition = () => {
      camera.updateMatrixWorld();      
      return camera.position
    }
  }, []);


  useEffect(() => {
    if (mesh.current) {
      mesh.current.rotation.x = rotationValues.x;
      mesh.current.rotation.y = rotationValues.y;
      mesh.current.rotation.z = rotationValues.z;
    }
  }, [mesh.current])

  useFrame((state) => {
    if(time.current || time.current == 0) {
    time.current += 0.0003;
    mesh.current.material.uniforms.time.value = time.current;
    }

  });

 

  return (
    <mesh
      ref={mesh}
      position={[0.2, 0, 0]}
      rotation={[0,0, 0]}
      scale={1.5}
    >
      <planeGeometry args={[2, 2, 200, 200]} />
      <shaderMaterial
        extensions={{
          derivatives: "#extension GL_OES_standard_derivatives : enable",
        }}
        side={DoubleSide}
        uniforms={uniforms}
        fragmentShader={fragmentShader}
        vertexShader={vertexShader}
      />
    </mesh>
  );
};

const Scene = () => {
  const camPos = {x: 0.09775412931392037, y: 0.08933801074741582, z: 0.12447328551861743}
   // Use the useState hook to store the camera position
   const [cameraPosition, setCameraPosition] = useState({ x: camPos.x, y: camPos.y, z: camPos.z });
   // Set the default camera to the cameraRef
  return (
    <Canvas camera={{ position: [cameraPosition.x, cameraPosition.y, cameraPosition.z]}}
    style={{ 
      position: 'absolute',
      width: '100%',
      height: '100%',
      /* overflow: 'hidden', */
      pointerEvents: 'auto',
      zIndex: -1,
    }}
    >
      <LavaLamp />
    </Canvas>
  );
};

export default Scene;
